import {AxiosInstance} from "axios";
import {PhoneValidationResult} from "../model/validation/PhoneValidationResult";

export default class ValidationApi {
	constructor(public readonly axiosInstance: AxiosInstance) { }

	/**
	 * Validate phone number
	 * @param {string} phoneNumber
	 * @returns {Promise<PhoneValidationResult>}
	 */
	validatePhone(phoneNumber: string): Promise<PhoneValidationResult> {
		const url = `/api/web/validate/phone_number/`;
		const params = {params: {phoneNumber}};
		return this.axiosInstance.get(url, params).then(resp => PhoneValidationResult.fromJson(resp.data));
	}
}